<template>
    <div class="animated fadeIn">
        <spinner v-if="loading"/>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>SRF DO Listings</strong>
                    </div>
                    <b-row>
                        <b-col sm="3">
                            <label>Doc. No</label>
                            <b-form-group>
                                <b-form-input type="text" v-model="filter.doc_num"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label>Doc. Date</label>
                                <b-form-input type="date" v-model="filter.doc_date"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label>From Date</label>
                                <b-form-input type="date" v-model="filter.from_date"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label>To Date</label>
                                <b-form-input type="date" v-model="filter.to_date"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div slot="footer">
                        <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="searchResults.length >0 && !loading">
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>SRF Listings</strong>
                    </div>
                    <b-row>
                        <b-col sm="12">
                            <div class="table-responsive">
                                <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :items="searchResults"></b-table>
                            </div>
                            <nav>
                                <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                            </nav>
                        </b-col>
                    </b-row>
                    <div slot="footer">
                        <exportExcel class   = "btn btn-primary btn-lg" size ="lg" :data = "searchResults" :fields = "exportHeaders" name = "back_orders.xls">
                            Export to Excel
                        </exportExcel>
                        &nbsp;&nbsp;
                        <b-button type="submit" size="lg" variant="success" @click="print">Print</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-else-if="noResults && !loading" >
                <b-col sm="12">
                  <div align="center">
                    <strong>No Records Found</strong>
                  </div>                    
                </b-col>
        </b-row>
    </div>
</template>
<script>
import axios from 'axios'
import spinner from '@/components/Spinner.vue'
import countryLookup from '@/components/Autocomplete.vue'
import warehouseLookup from '@/components/Autocomplete.vue'
import {authHeader, apiCountryLookup,apiWarehouseLookup,apiPodUpdate,apiPodSearch,apiBackOrdersSearch, apiSrfDoListingReport} from '@/functions/common.vue'

 import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
      "ukai": {
         normal: 'ukai.ttf',
          bold: 'ukai.ttf',
          italics: 'ukai.ttf',
           bolditalics: 'ukai.ttf'
      },
   };

import exportExcel from 'vue-json-excel'

export default
{
    components:{spinner,countryLookup,warehouseLookup,exportExcel},
    props: 
    {
      caption: 
      {
        type: String,
        default: 'Table'
      },
      hover: 
      {
        type: Boolean,
        default: false
      },
      striped: 
      {
        type: Boolean,
        default: false
      },
      bordered: 
      {
        type: Boolean,
        default: false
      },
      small: 
      {
        type: Boolean,
        default: false
      },
      fixed: 
      {
        type: Boolean,
        default: false
      }
    },
    data()
    {
        return{
            loading:false,
            apiCountryLookup:apiCountryLookup,
            apiWarehouseLookup:apiWarehouseLookup,
            filter: 
            {
                doc_num:'',
                doc_date: '',
                from_date:'',
                to_date:''
            },  
            exportHeaders:
            {
              'Trans Date': 'doc_date',
              'Doc #':'doc_num',
              'From Date':'from_date',
              'To Date':'to_date',
              'Expired Date':'expired_date',
              'SKU':'product_code',
              'Qty':'qty',
              'Unit Price':'unit_price',
              'Total':'total'
            }, 
            searchResults: [],
            searchResultsFields: 
            [
                {key: 'doc_date', label: 'Doc. Date'},
                {key: 'doc_num', label: 'Doc. No'},
                {key: 'from_date', label: 'From Date'},
                {key: 'to_date', label: 'To Date'},
                {key: 'expired_date', label: 'Expired Date'},
                {key: 'product_code', label: 'SKU'},
                {key: 'product_name', label: 'Product Name'},
                {key: 'qty', label: 'Qty'},
                {key: 'unit_price', label: 'Unit Price'},
                {key: 'total', label: 'Total'},

            ],
            currentPage: 1,
            perPage: 30,
            totalRows: 0,
            noResults: false
            }
    },
    methods:
    {
        print()
        {
          var rows = []
          var row = []
          var date = new Date()
          //Doc. Date	Doc. No	From Date	To Date	Expired Date	SKU	Product Name	Qty	Unit Price	Total
          rows.push([
          'Doc. Date',
          'Doc. No',
          'From Date',
          'To Date',
          'Expired Date',
          'SKU',
          'Product Name',
          'Qty',
          'Uni Price',
          'Total',
          ])

          for (let key in this.searchResults)
          {
            var data = this.searchResults[key]
            row = [
                data.doc_date,
                data.doc_num,
                data.from_date,
                data.to_date,
                data.expired_date,
                data.product_code,
                data.product_name,
                data.qty,
                data.unit_price,
                data.total
            ]
            rows.push(row)
          }
          var dd = {
            header:{ text: 'SRF DO Listing generated on'+ " "+ date, margin: [ 5, 7, 10, 30 ],alignment: 'center',fontSize:7 },
            pageSize: 'A4',
            pageOrientation: 'portrait',
          
            // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
            pageMargins: [30, 20, 30, 20 ],
            defaultStyle: {
            font: 'ukai'
          },
            content: [
              {
                fontSize: 8.5,
                layout: 'lightHorizontalLines', // optional
                table: {
                  // headers are automatically repeated if the table spans over multiple pages
                  // you can declare how many rows should be treated as headers
                  headerRows: 1,
                  widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto' ],
                  body: 
                    rows
                  
                }
              }
            ]
          };

          pdfMake.createPdf(dd).open();
        },
        search()
        {
            this.loading = true
            this.submitted =true
            this.seen =true
            var sf =
            [
                "doc_num LIKE " + this.filter.doc_num
                ,"doc_date = " + this.filter.doc_date
                ,"from_date = " + this.filter.from_date
                ,"to_date = " + this.filter.to_date
                ,"returning_type <> " + 'NON RETURNABLE'
            ]
              axios.post(apiSrfDoListingReport, sf,authHeader())
                .then (res => 
                {
                  return res
                  
                })
                .then (data =>
                {
                  const resultArray = []
                  const myData = data.data.data
                  
                  for (let key in myData)
                  {
                    var date = myData[key].do_date
                    var date = new Date(date);
                    var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    myData[key].po_date = result

                    var from_date = myData[key].from_date
                    var from_date = new Date(from_date);
                    var from_result = "" + (from_date.getDate() > 9 ? '' : '0') + from_date.getDate() + '/'+  ((from_date.getMonth() + 1) > 9 ? '' : '0') + (from_date.getMonth() + 1) + '/' + from_date.getFullYear()
                    myData[key].from_date = from_result

                    var to_date = myData[key].to_date
                    var to_date = new Date(to_date);
                    var to_result = "" + (to_date.getDate() > 9 ? '' : '0') + to_date.getDate() + '/'+  ((to_date.getMonth() + 1) > 9 ? '' : '0') + (to_date.getMonth() + 1) + '/' + to_date.getFullYear()
                    myData[key].to_date = to_result 

                    
                    var expired_date = myData[key].expired_date
                    var expired_date = new Date(expired_date);
                    var expired_result = "" + (expired_date.getDate() > 9 ? '' : '0') + expired_date.getDate() + '/'+  ((expired_date.getMonth() + 1) > 9 ? '' : '0') + (expired_date.getMonth() + 1) + '/' + expired_date.getFullYear()
                    myData[key].expired_date = expired_result

                    resultArray.push(myData[key])
                    this.loading = false
                  }
           
                  this.searchResults = myData
                  if(this.searchResults.length ==0)
                  {
                    this.loading = false
                    this.noResults =true
                  }
                })
                .catch(error => console.log(error))
        },
        setCountry(obj)
        {
            var id

                if (obj !== null)
                {
                    id = obj.id
                } 
                else
                {
                    id = ""
                }
            this.filter.country_id = id
        },
        setWarehouse(obj)
        {
            var id

                if (obj !== null)
                {
                    id = obj.id
                } 
                else
                {
                    id = ""
                }
            this.filter.location_id = id
        },
        getRowCount (items) 
        {
            return items.length
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/reports/srf_do_listing.vue